import React from "react";

export const ViewBills = () => {
  return <div>ViewBills</div>;
};
